/*
 * DTFNY · Live cutoff countdown.
 *
 * Updates every second to show time remaining until today's cutoff in
 * a configured timezone. After the cutoff passes, switches to an
 * 'order for tomorrow's batch' message and counts down to tomorrow's
 * cutoff. Pauses when the tab is hidden (Page Visibility API).
 *
 * Markup the bar needs (rendered by sections/dtfny-countdown.liquid):
 *   <element data-countdown-bar
 *            data-cutoff="13:00"
 *            data-tz="America/New_York">
 *     <element data-countdown-active>
 *       …text…<span data-countdown-time></span>…text…
 *     </element>
 *     <element data-countdown-after hidden>
 *       …after-cutoff text…
 *     </element>
 *   </element>
 */
(function () {
  /** Get the hour/minute/second of "now" in the target timezone. */
  function nowInTimezone(timezone) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());

    var out = { hour: 0, minute: 0, second: 0 };
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type === 'hour' || p.type === 'minute' || p.type === 'second') {
        out[p.type] = parseInt(p.value, 10) || 0;
      }
    }
    return out;
  }

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function init(bar) {
    var cutoff = (bar.dataset.cutoff || '13:00').split(':');
    var cutoffH = parseInt(cutoff[0], 10) || 13;
    var cutoffM = parseInt(cutoff[1], 10) || 0;
    var tz = bar.dataset.tz || 'America/New_York';

    var activeEl = bar.querySelector('[data-countdown-active]');
    var afterEl = bar.querySelector('[data-countdown-after]');
    var hEl = bar.querySelector('[data-countdown-h]');
    var mEl = bar.querySelector('[data-countdown-m]');
    var sEl = bar.querySelector('[data-countdown-s]');
    if (!activeEl || !afterEl || !hEl || !mEl || !sEl) return;

    var intervalId = null;

    function tick() {
      var now = nowInTimezone(tz);
      var nowSecs = now.hour * 3600 + now.minute * 60 + now.second;
      var cutoffSecs = cutoffH * 3600 + cutoffM * 60;

      var diff;
      var isAfter;

      if (nowSecs < cutoffSecs) {
        diff = cutoffSecs - nowSecs;
        isAfter = false;
      } else {
        // Cutoff passed for today; count down to the next day's cutoff.
        diff = 24 * 3600 - nowSecs + cutoffSecs;
        isAfter = true;
      }

      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;

      hEl.textContent = pad2(h);
      mEl.textContent = pad2(m);
      sEl.textContent = pad2(s);

      if (isAfter) {
        activeEl.setAttribute('hidden', '');
        afterEl.removeAttribute('hidden');
      } else {
        afterEl.setAttribute('hidden', '');
        activeEl.removeAttribute('hidden');
      }
    }

    function start() {
      tick();
      if (intervalId) clearInterval(intervalId);
      intervalId = setInterval(tick, 1000);
    }

    function stop() {
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function bootstrap() {
    document.querySelectorAll('[data-countdown-bar]').forEach(function (el) {
      if (el.dataset.countdownInit) return;
      el.dataset.countdownInit = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-bootstrap on Shopify section render (Theme Editor).
  document.addEventListener('shopify:section:load', bootstrap);
})();
